import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

import HeroVideo from "../HeroVideo/HeroVideo";
import ScrollButton from "../ScrollButton/ScrollButton";

import {
  HeroBnrContainer,
  HeroBnrContainerInner,
  HeroBnrContent,
  HeroBnrDtl,
  HeroBnrVideo,
} from "./HeroBanner.styles";

gsap.registerPlugin(ScrollTrigger);

interface IHeroVideo {
  src: string;
  poster: string;
}

interface IHeroBanner {
  title: string;
  src: string;
  alt: string;
  heroVideo: IHeroVideo;
}

const HeroBanner = ({ title, src, alt, heroVideo }: IHeroBanner) => {
  const mainRef = useRef<any>();
  const headingRef = useRef<any>();
  const videoRef = useRef<any>();
  const bgImageRef = useRef<any>();
  const buttonRef = useRef<any>();

  const [windowHeight, setWindowHeight] = useState<any>();
  useEffect(() => {
    setWindowHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    const bgImage = bgImageRef.current;
    // if(windowHeight == null){
    //     return;
    // }

    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function () {
        gsap.to(headingRef.current, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "50% 40%",
            end: "50% 20%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
          },
          opacity: 0,
          duration: 2,
        });
        gsap.to(buttonRef.current, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "50% 40%",
            end: "50% 30%",
            pinSpacing: false,
            toggleActions: "restart resume none reverse",
            scrub: true,
          },
          opacity: 0,
          duration: 2,
        });
        gsap.to(video, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: `+=${((windowHeight * 70) / 100) * 3}`,
            pin: video,
            pinSpacing: false,
          },
        });
        gsap.to(bgImage, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: `+=${((windowHeight * 70) / 100) * 3}`,
            pin: bgImage,
            pinSpacing: false,
          },
        });
      },
      "(max-width: 767px)": function () {
        gsap.to(video, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top -18%",
            end: `+=${((windowHeight * 25) / 100) * 3}`,
            pin: video,
            pinSpacing: false,
          },
        });
        gsap.to(bgImage, {
          scrollTrigger: {
            trigger: mainRef.current,
            start: "top top",
            end: `+=${((windowHeight * 25) / 100) * 3}`,
            pin: bgImage,
            pinSpacing: false,
          },
        });
      },
    });
  }, [windowHeight]);
  return (
    <HeroBnrContainer ref={mainRef} id="heroBanner">
      <HeroBnrContainerInner>
        <HeroBnrContent>
          <HeroBnrDtl id="heroBnrDtl">
            <h1 ref={headingRef}>{title}</h1>
            <ScrollButton buttonRef={buttonRef} />
          </HeroBnrDtl>
          <HeroBnrVideo ref={videoRef}>
            <HeroVideo src={heroVideo?.src} poster={heroVideo?.poster} />
          </HeroBnrVideo>
        </HeroBnrContent>
      </HeroBnrContainerInner>
      <img src={src} alt={alt} ref={bgImageRef} />
    </HeroBnrContainer>
  );
};

export default HeroBanner;
